import { Network } from 'lucide-react';
import { useWorkspaceStore } from '@/stores/workspace-store';
import type { SearchItem, SearchProvider } from '../types';
import type { TunnelConfig } from '@/types';

export const tunnelSearchProvider: SearchProvider = {
  id: 'tunnels',
  kind: 'tunnel',
  list: (ctx) => {
    const tunnels = ctx.queryClient?.getQueryData<TunnelConfig[]>(['tunnels']) ?? [];
    return tunnels.map<SearchItem>((t) => ({
      id: `tunnel:${t.id}`,
      kind: 'tunnel',
      label: t.name,
      subtitle: `${t.username}@${t.host}:${t.port}`,
      icon: Network,
      tint: t.colorTag ?? undefined,
      boost: 0.6,
      action: () => {
        useWorkspaceStore.getState().openTab({
          type: 'tunnel',
          id: `tunnel:${t.id}`,
          tunnelId: t.id,
          tunnelName: t.name,
        });
      },
    }));
  },
};
